import React from 'react'
import cn from 'classnames'
import { Form, Select } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import PageHeader from '../PageHeader'
import Button from '../../sharedForm/Button'
import SaveIndicator from '../../sharedForm/SaveIndicator'

import {
  NUMBER_OF_EMPLOYEES_OPTIONS_V5,
  INDUSTRY_OPTIONS_V5,
  CUSTOMER_HELP_QUESTION_OPTIONS_V5,
} from '../../sharedForm/constants'

import sharedStyles from '../../sharedForm/styles.less'

class CompanyPage extends React.PureComponent {
  state = {
    focusedField: null,
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    if (this.state.focusedField === name) {
      onValidate(name, formFields[name])
    }
    this.setState({ focusedField: null })
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
      isLastStep,
      isOnboardingComplete,
    } = this.props
    const { focusedField } = this.state
    const buttonText = isLastStep ? 'Finish' : 'Continue'
    return (
      <>
        <PageHeader />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV3)}
        >
          <Form.Field>
            <label htmlFor="name">Company name</label>
            <ValidatedField
              placeholder="Where do you work?"
              name="companyName"
              value={formFields.companyName}
              errorMessage={
                focusedField !== 'companyName' && formFieldsErrors.companyName
              }
              onChange={propFunc(this.handleChange, 'companyName')}
              onFocus={propFunc(this.handleFocus, 'companyName')}
              onBlur={propFunc(this.handleBlur, 'companyName')}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="industry">Industry</label>
            <Select
              name="industry"
              className="large"
              options={INDUSTRY_OPTIONS_V5}
              value={formFields.industry}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'industry')}
              onFocus={propFunc(this.handleFocus, 'industry')}
              onBlur={propFunc(this.handleBlur, 'industry')}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="numberOfEmployees">
              Number of {app.t('agents')} using Groove
            </label>
            <Select
              name="numberOfEmployees"
              className="large"
              options={NUMBER_OF_EMPLOYEES_OPTIONS_V5}
              value={formFields.numberOfEmployees}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'numberOfEmployees')}
              onFocus={propFunc(this.handleFocus, 'numberOfEmployees')}
              onBlur={propFunc(this.handleBlur, 'numberOfEmployees')}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor="currentSupportSolution">
              Current support solution
            </label>
            <Select
              name="currentSupportSolution"
              className="large"
              options={CUSTOMER_HELP_QUESTION_OPTIONS_V5}
              value={formFields.currentSupportSolution}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'currentSupportSolution')}
            />
          </Form.Field>

          <Button
            disabled={!canSave || saving || isOnboardingComplete}
            onClick={submitForm}
          >
            {!saving && !isOnboardingComplete ? (
              buttonText
            ) : (
              <SaveIndicator animate>Saving</SaveIndicator>
            )}
          </Button>
        </Form>
      </>
    )
  }
}

export default CompanyPage
